import React, { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";

/* CSS를 가지고있는 기본 input */
export default function BasicSelect({ item, onChange, onClick, value, readOnly, width, onKeyDown }) {
    const defaultValue = item.option && item.option.length > 0 ? item.option[0].value : "";
	const val = value != null && (typeof value).toLowerCase() === "boolean" ? value.toString() : value;	// boolean은 정상 처리 되지 않아서 문자열로 변경
	
    return (
        <>
			<div onKeyDown={onKeyDown && (e => onKeyDown(e))}>
				<select
					id={uuidv4()}
					className="basic-input"
					name={item.col || ""}
					onChange={onChange && ((e) => onChange(e))}
					onClick={onClick && ((e) => onClick(e))}
					value={val || defaultValue}
					placeholder={item.placeholder || ""}
					readOnly={readOnly || false}
					disabled={item.disabled || false}
					style={{width : width}}>
					{item.option &&
						item.option.map((op, index) => (
							<option key={index} value={op.value}>
								{op.label}
							</option>
						))}
				</select>
			</div>
        </>
    );
}
